"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var themes_1 = require("../../themes");
var StyledLink_1 = require("./StyledLink");
var LinkInner = function (_a) {
    var color = _a.color, secondaryColor = _a.secondaryColor, tag = _a.tag, icon = _a.icon, iconAlign = _a.iconAlign, children = _a.children, textUnderline = _a.textUnderline, rest = tslib_1.__rest(_a, ["color", "secondaryColor", "tag", "icon", "iconAlign", "children", "textUnderline"]);
    return (React.createElement(StyledLink_1.StyledLink, tslib_1.__assign({ hasIcon: !!icon, colorProp: color, secondaryColorProp: secondaryColor, textUnderline: textUnderline, as: tag || 'a' }, rest), iconAlign && iconAlign === 'right' ? (React.createElement(React.Fragment, null,
        children,
        " ",
        icon)) : (React.createElement(React.Fragment, null,
        icon,
        " ",
        children))));
};
LinkInner.defaultProps = {
    level: 1,
    tag: 'a',
    color: themes_1.colors['primaryBlue-1'],
    secondaryColor: themes_1.colors['secondaryBlue-1'],
    textUnderline: true,
    completeTransition: true,
    iconAlign: 'left',
    hover: true
};
/** @component */
exports.Link = recompose_1.compose(styled_components_1.withTheme)(LinkInner);
//# sourceMappingURL=Link.js.map